import { Typography as MuiTypography, type TypographyProps as MuiTypographyProps } from '@mui/material';

import type { WithoutStyleOverrides } from '../../../types/WithoutStyleOverrides';

type Props = WithoutStyleOverrides<Omit<MuiTypographyProps, 'color'>>;

export function Typography(props: Props) {
  return <MuiTypography {...props} />;
}

export type { Props as TypographyProps };
